/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

require("prismjs/themes/prism.css")

export const onClientEntry = () => {
    if (window.location.hash.includes("_token")) {
        const { netlifyIdentity } = window
        if (netlifyIdentity) {
            netlifyIdentity.on("init", user => {
                if (!user) {
                    netlifyIdentity.on("login", () => {
                        document.location.href = "/admin/"
                    })
                }
            })
        }
    }
}
